import { Injectable } from '@angular/core';
import { BehaviorSubject, take } from 'rxjs';
import { Bookmark } from '../models/bookmark';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root',
})
export class BookmarkService {
  public constructor(private httpClient: HttpClient) { }

  private readonly apiUrl = '/api/Bookmark/';

  private bookmarksSubject = new BehaviorSubject<Bookmark[] | null>(null);
  bookmarks$ = this.bookmarksSubject.asObservable();

  getBookmarks(projectId: string): void {
    this.httpClient.get<Bookmark[]>(this.apiUrl + projectId + '/get').pipe(take(1)).subscribe({
      next: (result) => this.bookmarksSubject.next(result),
      error: (err) => console.error('Ошибка загрузки закладок', err),
    });
  }

  addBookmark(bookmark: Bookmark): void {
    this.httpClient.post<Bookmark>(this.apiUrl + 'create', bookmark).subscribe()
  }

  deleteBookmark(id: string, projectId: string): void {
    this.httpClient.delete(this.apiUrl + id + '/delete').subscribe()
  }

  reset() {
    this.bookmarksSubject.next(null);
  }

  addLocal(bookmark: Bookmark): void {
    const bookmarks = this.bookmarksSubject.value;
    if (!bookmarks) return;

    this.bookmarksSubject.next([...bookmarks, bookmark].sort((a, b) => a.name.localeCompare(b.name)));
  }

  updateLocal(bookmark: Bookmark): void {
    const bookmarks = this.bookmarksSubject.value;
    if (!bookmarks) return;

    this.bookmarksSubject.next(
      bookmarks.map(b => b.id === bookmark.id ? bookmark : b).sort((a, b) => a.name.localeCompare(b.name)));
  }

  removeLocal(bookmarkId: string): void {
    const bookmarks = this.bookmarksSubject.value;
    if (!bookmarks) return;

    this.bookmarksSubject.next(
      bookmarks.filter(b => b.id !== bookmarkId).sort((a, b) => a.name.localeCompare(b.name)));
  }
}
